import { Button, HStack, Text, VStack } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import type { ReactElement } from 'react'

import AuthLink from '@/components/Auth/AuthLink'
import SignupButton from '@/components/Buttons/SignupButton'

export default function LoggedOutDiscussionView({
  type,
}: {
  type: 'session' | 'series'
}): ReactElement {
  const router = useRouter()
  return (
    <VStack
      spacing="16px"
      rounded="md"
      p="48px"
      border="2px solid"
      borderColor="border"
      justify="center"
    >
      <Text align="center">Please log in to see discussion on this {type}.</Text>
      <HStack justify="center">
        <AuthLink mode="login" returnTo={router.asPath}>
          <Button variant="outline" textDecoration="none">
            Sign In
          </Button>
        </AuthLink>
        <SignupButton />
      </HStack>
    </VStack>
  )
}
